import React from "react";
import Loader from "../Common/Loader/Loader";
import cx from "classnames"
import { Container } from "react-bootstrap";
import { formValueSelector } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";

import ClearAll from "./ClearAll/ClearAll";
import ClearCart from "./ClearCart/ClearCart";
import CommonModal from "../Modal/CommonModal";

import messages from "../../locale/messages";

import { addOrderAction } from "../../actions/order/addOrderAction";
import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";
import { writeGuestCart } from "../../helpers/bookingDraft";
import { setRuntimeVariable } from '../../actions/runtime';
import history from "../../history";

import useQueryResponse from "../../lib/hooks/useQueryResponse";
import getOrder from "./getOrder.graphql";
import bt from '../commonStyle.css';
import s from "./ReviewYourRequestBanner.css"


const ReviewYourRequestBanner = (props) => {
    const {
        resetForm,
        currentCategoryId,
        requestCurrency,
        intl: { formatMessage },
        closeHeaderModal,
        openHeaderModal,
        addOrderAction,
        ordersData,
        loading,
        clearSubCategory,
        clearCart,
        isAuthenticated
    } = props

    const { data, loading: getOrderLoading } = useQueryResponse({
        query: getOrder,
        variables: {
            promoId: null
        },
        ssr: false,
        fetchPolicy: 'network-only'
    })
    const closeClearSubCategoryModal = () => {
        closeHeaderModal('clearSubCategory')
    }

    const closeClearCartModal = () => {
        closeHeaderModal('clearCart')
    }

    const handleClick = () => {
        // GA4 funnel: the "Review your request" click is the start of checkout — the
        // step GA showed everyone abandoning. login_prompt fires only on the guest branch.
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'begin_checkout');
            if (!isAuthenticated) window.gtag('event', 'login_prompt', { context: 'review_request' });
        }
        // Defer login to the booking action (app parity): a GUEST can fill the whole cart on /category.
        // The order/booking layer is user-scoped server-side (we keep that wall), so instead of creating
        // a guest order we stash the cart and send the guest through the existing login-with-return flow.
        // After login, /order/replay replays this cart into a real order. The guest fills everything else
        // (description / questionnaire / schedule / payment) only after this single auth step.
        if (!isAuthenticated) {
            // DEFER LOGIN TO THE END (approach B): a logged-out guest no longer hits login here. Stash
            // the cart and take them to the guest review screen where they fill description / schedule /
            // matching and see the real price. Account + card + booking fire only on that screen's final
            // CTA — mirroring TaskRabbit (account at worker selection, payment at the very end).
            writeGuestCart(ordersData)
            history.push('/order-review')
            return
        }
        const orderId = data?.getOrder?.result?.id, selectedCategoryId = data?.getOrder?.result?.categoryDetails?.id
        if (orderId && (currentCategoryId !== selectedCategoryId)) {
            openHeaderModal('clearCart')
        }

        else {
            addOrderAction(ordersData)
        }
    }
    const orderId = data?.getOrder?.result?.id
    return (
        <>
            <CommonModal
                title={clearSubCategory ? formatMessage(messages.clearAllTitle) : formatMessage(messages.clearCart)}
                onHide={clearSubCategory ? closeClearSubCategoryModal : closeClearCartModal}
                modalStatus={clearSubCategory ? clearSubCategory : clearCart} >
                {clearSubCategory ? <ClearAll resetForm={resetForm} /> : <ClearCart resetForm={resetForm} orderId={orderId} />}
            </CommonModal >
            <div className={s.reviewYourRequestContainer}>
                <Container>
                    <div className={s.reviewYourRequestWrapper}>
                        <div onClick={() => openHeaderModal('clearSubCategory')} className={bt.viewAllLink}><FormattedMessage {...messages.clearAll} /> </div>
                        <Loader
                            type={"button"}
                            buttonType={'button'}
                            label={formatMessage(messages.reviewYourRequest)}
                            show={loading}
                            handleClick={handleClick}
                            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        >
                        </Loader>
                    </div>
                </Container>
            </div>
        </>
    )
}
const selector = formValueSelector('BookingForm')
const mapState = (state) => ({
    ordersData: selector(state, 'orderData'),
    loading: state.loader?.orderLoading,
    clearSubCategory: state.adminModalStatus.clearSubCategory,
    clearCart: state.adminModalStatus.clearCart,
    isAuthenticated: state.runtime?.isAuthenticated,
})
const mapDispatch = {
    addOrderAction,
    openHeaderModal,
    closeHeaderModal,
    setRuntimeVariable
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(ReviewYourRequestBanner)))